import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import { showAdminEmployeeRequest } from '../../../requests/adminEmployees';
import { EmployeeTopView } from '../../../components';
import EmployeeTabs from './EmployeeTabs';

import basicEmployee from './employee';

const EmployeeShow = ({ match }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [employee, setEmployee] = useState(basicEmployee);
  const dispatch = useDispatch();
  const { params } = match;

  const fetchEmployee = () => {
    setOnRequest(true);
    showAdminEmployeeRequest(params.id, {
      dispatch,
      successCallback: response => setEmployee(camelCaseEmptyStringRecursive(response.data)),
      callback: () => setOnRequest(false)
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(fetchEmployee, [params.id]);

  return (
    <div className={`${onRequest && 'bg-opacity'}`}>
      {onRequest && (
        <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {!onRequest && (
        <>
          <EmployeeTopView
            employee={employee.employeeCard}
            editTo="/admin/employees"
            returnTo="/admin/employees"
            canEdit
          />
          <EmployeeTabs employee={employee} />
        </>
      )}
    </div>
  );
};

export default EmployeeShow;
